
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type { Referrer } from '@/types';

import useClipboard from '@/composable/useClipboard';

export default defineComponent({
  props: {
    referrer: {
      type: Object as PropType<Referrer>,
    },
  },
  setup() {
    const { copyToClipboard } = useClipboard();

    return {
      copyToClipboard,
    };
  },
});
